module.exports = __webpack_public_path__ + "8a1a59ab50f4cb9db35d1386d6b11877.jpg";